import './App.css';
import Navbar from './Components/Navbar';
import Hero from './Components/Hero';
import AboutUs from './Components/AboutUs';
import Products from './Components/Products';
import Gallery from './Components/Gallery';
import Contact from './Components/Contact';
import Footer from './Components/Footer';

function App() {
  return (
    <>
     {/* <h1>hello world</h1> */}
     
     <Navbar />
    <Hero />
     <AboutUs />
     <Products />
     <Gallery />
     <Contact />
     <Footer />
    

    </>
  );
}

export default App;
